/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { UpdateClusterActions, UpdateClusterActionTypes, UpdateClusterParams } from './types';

export const openUpdateClusterOverlay = ({ serviceType }: UpdateClusterParams): UpdateClusterActionTypes => ({
  type: UpdateClusterActions.OPEN_UPDATE_CLUSTER_OVERLAY,
  payload: {
    serviceType,
  },
});

export const closeUpdateClusterOverlay = (): UpdateClusterActionTypes => ({
  type: UpdateClusterActions.CLOSE_UPDATE_CLUSTER_OVERLAY,
});
